import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import DatosContacto from "../DatosContacto"
import DireccionSocial from "../DireccionSocial"
import RazonSocial from "../RazonSocial"
import { SaldoPendiente } from "../SaldoPendiente"

const DatosBasicos = ({
  contacto,
  contactoByIdRefetch,
}: {
  contacto?: ContactoReadingDtoProps
  contactoByIdRefetch: () => void
}) => {
  return (
    <div className='tw-p-8 tw-w-1/4 tw-h-full tw-bg-simple-10 tw-overflow-y-auto'>
      <RazonSocial
        razonSocial={contacto?.razonSocial}
        cif={contacto?.nif}
      />
      <DatosContacto empresaContactoId={contacto?.empresaContactoId} />
      <DireccionSocial
        empresaContactoId={contacto?.empresaContactoId}
        direccion={contacto?.direccion}
        contactoByIdRefetch={contactoByIdRefetch}
      />
      <SaldoPendiente />
    </div>
  )
}

export default DatosBasicos
